export const reverseIt = (theString, numbers = true, dashes = true, eng = true) => {
  let theLineChars = '\n\r'
  let theStraightChars = ''
  if (numbers) theStraightChars = '0123456789' + theStraightChars
  if (dashes) theStraightChars = './:-' + theStraightChars
  if (eng) theStraightChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz' + theStraightChars
  let theReverse = ''
  let theReverseArea = ''
  let theStraightBuffer = ''
  if (!theString) {
    theString = ''
  }
  let theLength = theString.length
  for (let i = 0; i < theLength; i++) {
    if (theLineChars.indexOf(theString.charAt(i)) >= 0) {
      if (theStraightBuffer != '') {
        theReverse = theStraightBuffer + theReverse
        theStraightBuffer = ''
      }
      theReverse = theReverse + theString.charAt(i)
    } else {
      if (theStraightChars.indexOf(theString.charAt(i)) >= 0) {
        theStraightBuffer = theStraightBuffer + theString.charAt(i)
      } else {
        if (theStraightBuffer != '') {
          theReverse = theStraightBuffer + theReverse
          theStraightBuffer = ''
        }
        theReverse = theString.charAt(i) + theReverse
      }
    }
    if (theString.charAt(i) == '\r') {
      theReverseArea = theReverseArea + theReverse
      theReverse = ''
    }
  }
  if (theStraightBuffer != '') {
    theReverse = theStraightBuffer + theReverse
    theStraightBuffer = ''
  }
  return (theReverseArea = theReverseArea + theReverse)
}
